import { ToggleInputProps } from '@usacsmideo/types';

export default function Toggle(props: ToggleInputProps) {
  return (
    <span className="my-4 inline-flex items-center gap-3 text-xl">
      <p>{props.leftSideLabel}</p>
      <div className="group has-checked:bg-mideo-darkred dark:has-checked:bg-mideo-darkred relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline outline-2 outline-offset-2 outline-gray-900 transition-colors duration-200 ease-in-out has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10">
        <span className="size-5 rounded-full bg-white ring-1 shadow-xs ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5" />
        <input
          name={props.name}
          type="checkbox"
          aria-label={props.label}
          className="absolute inset-0 appearance-none focus:outline-hidden"
          checked={props.checked}
          onClick={(e) => {
            props.onChange(!props.checked);
            e.stopPropagation();
          }}
        />
      </div>
      <p>{props.rightSideLabel}</p>
    </span>
  );
}
